import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { HiringStagePhaseFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  item: HiringStagePhaseFragment
  onEdit: (id: number) => void
  onDelete: (id: number) => void
}

export const StagePhaseItem = ({ item, onEdit, onDelete }: Props) => {
  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      gap="s24"
      paddingY="s24"
      paddingRight="s24"
      paddingLeft="s12"
      width="full"
      alignItems="center"
    >
      <Box flexDirection="row" gap="s4" alignItems="center" flexGrow cursor="pointer">
        <Icon.Medium icon="drag-and-drop" color="grey400" />
        <Text.Normal weight="medium">{item.name}</Text.Normal>
      </Box>

      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption
            title={i18n.t('common.edit')}
            onClick={() => onEdit(item.id)}
          />
          <PopoverMenu.TouchableOption
            title={i18n.t('common.destroy')}
            onClick={() => onDelete(item.id)}
            danger
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
